import { BaseAPI } from "./base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Viagens, InputPageViagens } from "@/models/viagens";
import { map } from "rxjs";
import Axios from "axios-observable";

export class ViagensApi extends BaseAPI<Viagens> {
  constructor() {
    super();
    this.apiUrl += "/viagem";
  }

  public getTravel(
    page: number,
    size: number,
    idOrigem: number,
    idDestino: number,
    dataInicio: string,
    dataFim: string
  ): AxiosObservable<Viagens> {
    //
    return this.axios
      .get(
        `${this.apiUrl}/list?page=${page}&size=${size}&municipio_origem_id=${idOrigem}&municipio_destino_id=${idDestino}&data_inicial=${dataInicio}&data_final=${dataFim}`,
        {}
      )
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  public details(id: number): AxiosObservable<Viagens> {
    return this.axios.get(`${this.apiUrl}/${id}`, {}).pipe(
      map((data: any) => {
        data = [data];
        return data;
      })
    );
  }
  public create(body: Viagens): AxiosObservable<Viagens> {
    return this.axios.post(`${this.apiUrl}/`, body);
  }

  public finishTravel(
    id: number,
    dataFim: string,
    latitude: string,
    longitude: string
  ): AxiosObservable<Viagens> {
    return this.axios.put(
      `${this.apiUrl}/finish?id=${id}&dataFim=${dataFim}&latitude=${latitude}&longitude=${longitude}`
    );
  }

  public returnTravel(body: Viagens): AxiosObservable<Viagens> {
    return this.axios.post(`${this.apiUrl}/back`, body);
  }

  public activeTravel(): AxiosObservable<Viagens> {
    return this.axios.get(`${this.apiUrl}/ativa`);
  }

  public permissionBackTravel(id: string): AxiosObservable<Viagens> {
    return this.axios.get(`${this.apiUrl}/validate-viagem-volta/${id}`).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
}
